import { forwardRef } from 'react'
import { useTranslation } from '@front/model'
import { createPolymorphicComponent } from '@mantine/core'
import { TButton, type TButtonProps } from './button'

type ButtonDeleteProps = Omit<TButtonProps, 'leftSection' | 'icon'>

const _ButtonDelete = forwardRef<HTMLButtonElement, ButtonDeleteProps>(({ children, ...props }, ref) => {
  const { t } = useTranslation()
  return (
    <TButton icon='delete' variant='destructive' {...props} ref={ref}>
      {children || t('Delete')}
    </TButton>
  )
})

_ButtonDelete.displayName = 'ButtonDelete'

export const ButtonDelete = createPolymorphicComponent<'button', ButtonDeleteProps>(_ButtonDelete)
